    <section class="mat-typography">
      <br />
      <h1>Audit Logs</h1>
    </section>
    <div class="padded-side-nav page-container">
      <div class="display-inputs-section">
        <mat-form-field class="default-input field">
          <mat-label>Action</mat-label>
          <input type="text" matInput placeholder="Action" [formControl]="ActionControl" />
        </mat-form-field>
          <mat-form-field class="default-input field" matError>
            <mat-label>Choose a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input #input1 matStartDate [formControl]="startDateControl" (focus)="picker.open()">
              <input #input2 [formControl]="endDateControl" matEndDate (focus)="picker.open()">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker (closed)="input1.blur(); input2.blur();"></mat-date-range-picker>
            @if(startDateControl.hasError('required') || endDateControl.hasError('required')) {
            <mat-error>Date missing from selection</mat-error>
            }@else if(startDateControl.hasError('futureDate') || endDateControl.hasError('futureDate')){
            <mat-error>Can't select a date in the future</mat-error>
            }
          </mat-form-field>
        <mat-form-field class="default-input field">
          <mat-label>Device</mat-label>
          <input type="text" matInput placeholder="Device" [formControl]="DeviceNumberControl" />
        </mat-form-field>
        <mat-form-field class="default-input field">
          <mat-label>User</mat-label>
          <input type="text" matInput placeholder="User" [formControl]="UserControl" />
        </mat-form-field>
        <div class="full-width">
          <div class="mauto ">
            <button mat-raised-button class="padded-btn" (click)="search()"><i class="material-icons">search</i>
              Search</button>
            <button mat-raised-button class="padded-btn" (click)="resetFields()"><i class="material-icons">replay</i>
              Reset</button>
          </div>
        </div>
      </div>

      <tools-table 
        [Headers]="auditLogHeaders" 
        #table 
        [HTTPPost]="true" 
        [ApiPath]="baseURL" 
        [HTTPData]="tableObj"
        [Search]="false" 
        [SortColumn]="'Timestamp'" 
        [Desc]="true">
      </tools-table>
    </div>